export const ArrowDownIcon = ({ className, color="white" }) => (
  <svg className={className} width="19" height="12" viewBox="0 0 19 12" fill={color} xmlns="http://www.w3.org/2000/svg">
    <path d="M2.67652 0.749023L9.56152 7.61902L16.4465 0.749023L18.5615 2.86402L9.56152 11.864L0.561523 2.86402L2.67652 0.749023Z" fill={color} />
  </svg>
);